export enum PersonStatus {
  Active = 'Active',
  Archived = 'Archived',
  Potential = 'Potential'
}
